export enum StatusApprovalsEnum {
    PENDING_WITH_HEAD_OF_TECHNICAL = "PENDING WITH HEAD OF TECHNICAL",
    HEAD_OF_TECHNICAL_APPROVED = "HEAD OF TECHNICAL APPROVED",
    HEAD_OF_TECHNICAL_REJECTED = "HEAD OF TECHNICAL REJECTED",
    PENDING_WITH_HEAD_OF_QUALITY = "PENDING WITH HEAD OF QUALITY",
    HEAD_OF_QUALITY_APPROVED = "HEAD OF QUALITY APPROVED",
    HEAD_OF_QUALITY_REJECTED = "HEAD OF QUALITY REJECTED",
    PENDING_WITH_SAMPLE_ROOM_MANAGER = "PENDING WITH SAMPLE ROOM MANAGER",
    SAMPLE_ROOM_MANAGER_APPROVED = "SAMPLE ROOM MANAGER APPROVED",
    SAMPLE_ROOM_MANAGER_REJECTED = "SAMPLE ROOM MANAGER REJECTED",
    PENDING_WITH_WARE_HOUSE = "PENDING WITH WARE HOUSE",
    WARE_HOUSE_APPROVED = "WARE HOUSE APPROVED",
    WARE_HOUSE_REJECTED = "WARE HOUSE REJECTED"
}